export const TACO_TYPES = [
  'Al Pastor',
  'Carne Asada',
  'Carnitas',
  'Chorizo',
  'Pollo',
  'Barbacoa',
  'Birria',
  'Lengua',
  'Fish',
  'Shrimp',
  'Ground Beef',
  'Cabeza',
  'Veggie',
]
